export const blockedDomains = [
  '163',
  'abv',
  'alice',
  'aliyun',
  'aol',
  'arnet',
  'att',
  'bellsouth',
  'blueyonder',
  'braintree',
  'btinternet',
  'charter',
  'checkout',
  'comcast',
  'cox',
  'cybersource',
  'daum',
  'earthlink',
  'fastmail',
  'fibertel',
  'freeserve',
  'games',
  'globalpayments',
  'globo',
  'globomail',
  'gmail',
  'gmx',
  'googlemail',
  'hanmail',
  'hotmail',
  'hush',
  'hushmail',
  'icloud',
  'iname',
  'inbox',
  'ingenico',
  'itelefonic',
  'juno',
  'laposte',
  'lavabit',
  'libero',
  'list',
  'live',
  'mac',
  'mail',
  'me',
  'mollie',
  'msn',
  'nate',
  'naver',
  'neuf',
  'ntlworld',
  'o2',
  'oi',
  'online',
  'outlook',
  'paypal',
  'pobox',
  'poste',
  'prodigy',
  'proonmail',
  'protonmail',
  'qq',
  'r7',
  'rambler',
  'rocketmail',
  'safe-mail',
  'sbcglobal',
  'sina',
  'skynet',
  'speedy',
  'stripe',
  't-online',
  'talktalk',
  'telenet',
  'teletu',
  'terra',
  'tin',
  'tiscali',
  'tvcablenet',
  'uol',
  'verizon',
  'virgilio',
  'virgin',
  'virginmedia',
  'voo',
  'wanadoo',
  'web',
  'wordline',
  'worldpay',
  'wow',
  'ya',
  'yahoo',
  'yandex',
  'ygm',
  'ymail',
  'zipmail',
  'zoho'
]
